import { Avatar, Box, Rating, Typography } from "@mui/material";

export default function ReviewList({ ratingArray, theme }) {
  return (
    <Box
      sx={{
        mt: 4,
        p: 3,
        borderRadius: 2,
        boxShadow: 2,
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: "bold",
          color: theme.palette.primary.main,
          mb: 3,
        }}
      >
        Reviews
      </Typography>
      {ratingArray.length > 0 ? (
        ratingArray?.map((review) => (
          <Box
            key={review.id}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              mb: 3,
              p: 2,
              borderRadius: 2,
              backgroundColor: theme.palette.background.paper,
              boxShadow: 1,
              transition: "transform 0.3s",
              "&:hover": {
                transform: "translateY(-2px)",
              },
            }}
          >
            <Avatar
              sx={{
                mr: 3,
                bgcolor: theme.palette.primary.light,
                color: theme.palette.primary.contrastText,
              }}
              src={review.profile_pic || undefined}
            >
              {review.reviewer.charAt(0).toUpperCase()}
            </Avatar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h6" sx={{ fontWeight: "bold", mb: 0.5 }}>
                {review.reviewer}
              </Typography>
              <Rating
                name={`rating-${review.id}`}
                value={review.rating_star}
                readOnly
                precision={0.5}
                size="small"
                sx={{ mb: 1 }}
              />
              <Typography variant="body2" sx={{ fontStyle: "italic", mb: 1 }}>
                "{review.comment}"
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: theme.palette.text.secondary,
                }}
              >
                {new Date(review.created).toLocaleDateString(undefined, {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </Typography>
            </Box>
          </Box>
        ))
      ) : (
        <Typography
          variant="body1"
          sx={{ color: theme.palette.text.secondary, mb: 2 }}
        >
          No reviews yet. Be the first to share your experience!
        </Typography>
      )}
    </Box>
  );
}
